import qwest from 'qwest';

export function saveVersion({version, smartLab = false, accuScan = false}) {
  qwest.post('/test-connect/version', {
    version,
    smartLab,
    accuScan,
  })
    .then((xhr, res) => res)
    .catch(err => {
      console.error(err);
      // Don't really care about the error here
    });
}
